import React, { useState } from "react";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function Summary({ data = {} }) {
  const limit = 170;
  const [showMoreSummary, setShowMoreSummary] = useState(false);
  const captureEvent = useCaptureEvent();
  return (
    <div className="">
      <div className="flex pt-4 pb-3 px-4 justify-between items-center ">
        <span className="text-[16px] text-text-700 mr-3 font-bold">Summary</span>
      </div>
      <div className="px-4 mb-4">
        <p className="text-gray-600 text-sm leading-7">
          {showMoreSummary
            ? data?.description
            : `${data?.description?.substring(0, limit)} ${limit < data?.description.length ? "... " : ""}` ||
              ""}
          {limit < data?.description?.length && (
            <span
              className={`text-brand-700 font-bold text-sm inline-block cursor-pointer ${
                showMoreSummary && "ml-1"
              }`}
              onClick={() => {
                setShowMoreSummary(!showMoreSummary);
                captureEvent(
                  showMoreSummary
                    ? "EXC_CompanyOverview_SummaryReadLessBtn"
                    : "EXC_CompanyOverview_SummaryReadMoreBtn"
                );
              }}
            >
              {showMoreSummary ? "Read less" : "Read more"}
            </span>
          )}
        </p>
      </div>
    </div>
  );
}
